import { head } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useFormReplies } from '../_load/FormRepliesLoader'
import { useFormRepliesActions } from '../../_actions/formRepliesActions'
import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import MultiSelectMenu from '../../../../packages/kiti/components/multiSelect/MultiSelectMenu'

const MultiRowsActions = () => {
  const formReplies = useFormReplies()
  const { selecteds, getSelectedData } = useMultiSelectState()
  const { t } = useTranslation()
  const selectedFormReplies = getSelectedData(formReplies)
  const [menuOptions, loading] = useFormRepliesActions(head(selectedFormReplies), selectedFormReplies)

  return <MultiSelectMenu loading={loading} options={menuOptions} />
}

export default MultiRowsActions
